import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_VIRTUAL_SWITCHES } from '@app/constants/virtualSwitches/virtualSwitches'
import { setVirtualSwitches, syncVirtualSwitchChannel } from '@app/actions/virtualSwitches/virtualSwitches'
import Api from '@app/api/virtualSwitches/virtualSwitches'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchVirtualSwitchesLogic = createLogic({
  type: SYNC_VIRTUAL_SWITCHES,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  process({ action }, dispatch, done) {
    dispatch(apiRequestSent(SYNC_VIRTUAL_SWITCHES))
    Api.virtualSwitches(action.accessToken)
      .then((response) => {
        const { data } = response
        dispatch(setVirtualSwitches(data.virtual_switches))
        dispatch(apiRequestDone(SYNC_VIRTUAL_SWITCHES))
        dispatch(syncVirtualSwitchChannel())
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('virtualSwitches failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchVirtualSwitchesLogic
